<template>
    <div>
        <config-main-title> Promedsys </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-4">
                <AzPeriodo v-model="filtros" :sync="true" @sync="sincronizarPeriodo" />
            </div>
            <div class="col col-12 col-md-2">
                <az-input
                    icon="fas fa-filter"
                    type="select"
                    placeholder="none"
                    :optionsList="opcoesTipo"
                    optionsData="value"
                    optionsDisplay="label"
                    v-model="tipoFiltro"
                />
            </div>
            <div class="col col-12 col-md-3">
                <az-input
                    icon="fas fa-search"
                    placeholder="Protocolo, #G(guia) ou #N(nº interno)..."
                    v-model="textoPesquisa"
                    @onEnter="recarregar(1)"
                />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-primary" @click="abrir_modal_executar()">
                    <i class="fas fa-play mr-1"></i> Executar
                </button>
            </div>
        </div>

        <div v-if="lista && lista_filtrada.length > 0">
            <div class="list-group mb-3 az-anime-surgir">
                <li
                    class="list-group-item list-group-item-action"
                    v-for="(log, id) in lista_filtrada"
                    :key="id"
                    @click="editar_log(log)"
                    style="cursor: pointer;"
                >
                    <div class="d-flex align-items-start">
                        <!-- Status -->
                        <div class="mr-3 mt-1" style="min-width: 90px;">
                            <span class="badge badge-pill" :class="log.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                <i :class="log.fl_sucesso ? 'fas fa-check' : 'fas fa-times'"></i>
                                {{ log.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                        </div>

                        <!-- Endpoint + erro/resumo -->
                        <div class="flex-grow-1 mr-3">
                            <div class="font-weight-bold text-dark">{{ endpointExibicao(log) }}</div>
                            <div v-if="!log.fl_sucesso && log.st_erro" class="text-danger small mt-1">
                                <i class="fas fa-exclamation-circle mr-1"></i>{{ log.st_erro }}
                            </div>
                            <div v-if="resumoConsulta(log)" class="text-muted small mt-1">
                                <span class="mr-3"><i class="fas fa-inbox mr-1"></i>Recebidos: <strong>{{ resumoConsulta(log).qt_total_recebido }}</strong></span>
                                <span class="mr-3"><i class="fas fa-cogs mr-1"></i>Processados: <strong>{{ resumoConsulta(log).qt_processado }}</strong></span>
                                <span class="mr-3"><i class="fas fa-exclamation-triangle mr-1 text-warning"></i>Inconsistências: <strong>{{ qtdInconsistencias(log) }}</strong></span>
                                <span class="mr-3"><i class="fas fa-check-circle mr-1 text-success"></i>Atualizados: <strong>{{ resumoConsulta(log).qt_atualizado }}</strong></span>
                                <span v-if="resumoConsulta(log).qt_nao_encontrado > 0" class="mr-3"><i class="fas fa-search mr-1"></i>Não encontrados: <strong>{{ resumoConsulta(log).qt_nao_encontrado }}</strong></span>
                                <span v-if="resumoConsulta(log).qt_erro > 0" class="text-danger"><i class="fas fa-times-circle mr-1"></i>Erros: <strong>{{ resumoConsulta(log).qt_erro }}</strong></span>
                            </div>
                            <div v-else-if="isEnvio(log) && (dadosEnvio(log) || protocoloEnvio(log))" class="text-muted small mt-1">
                                <span v-if="protocoloEnvio(log)" class="mr-3">
                                    <i class="fas fa-barcode mr-1"></i>Protocolo: <strong>{{ protocoloEnvio(log) }}</strong>
                                </span>
                                <span v-if="dadosEnvio(log) && dadosEnvio(log).guiasContidasRemessa != null" class="mr-3">
                                    <i class="fas fa-file-medical mr-1"></i>Guias: <strong>{{ dadosEnvio(log).guiasContidasRemessa }}</strong>
                                </span>
                                <span v-if="dadosEnvio(log) && dadosEnvio(log).identificadorRemessa != null" class="mr-3">
                                    <i class="fas fa-hashtag mr-1"></i>Remessa: <strong>{{ dadosEnvio(log).identificadorRemessa }}</strong>
                                </span>
                                <span v-if="dadosEnvio(log) && dadosEnvio(log).tokenRemessa" class="mr-3">
                                    <i class="fas fa-key mr-1"></i>Token: <strong>{{ dadosEnvio(log).tokenRemessa }}</strong>
                                </span>
                            </div>
                        </div>

                        <!-- Tipo -->
                        <div class="mr-3 mt-1 text-nowrap" style="min-width: 78px;">
                            <span
                                :class="isEnvio(log) ? 'text-warning' : 'text-info'"
                                style="font-size: 0.78rem;"
                            >
                                <i
                                    class="mr-1"
                                    :class="isEnvio(log) ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                                    :title="isEnvio(log) ? 'Envio' : 'Consulta'"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                ></i>
                                {{ isEnvio(log) ? 'Envio' : 'Consulta' }}
                            </span>
                        </div>

                        <!-- Datas -->
                        <div class="text-right text-nowrap" style="min-width: 210px;">
                            <div
                                class="px-2 py-1 rounded"
                                :style="isEnvio(log)
                                    ? 'background-color: #fff3cd; border-left: 3px solid #ffc107;'
                                    : 'background-color: #e8f4fd; border-left: 3px solid #3a9bd5;'"
                            >
                                <div class="small text-muted">{{ isEnvio(log) ? 'Data do envio' : 'Última consulta' }}</div>
                                <div
                                    class="font-weight-bold"
                                    :style="isEnvio(log)
                                        ? 'color: #856404; font-size: 0.95rem;'
                                        : 'color: #1a6fa0; font-size: 0.95rem;'"
                                >
                                    <i class="fas fa-clock mr-1"></i>{{ formatarData(log.dt_ultima_consulta) }}
                                </div>
                            </div>
                            <div class="small text-muted mt-1">
                                <i class="fas fa-calendar-alt mr-1"></i>Criado em: {{ formatarData(log.created_at) }}
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum log encontrado..." icon="fas fa-file-alt" />
        </div>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="recarregar"
                />
            </div>
        </nav>

        <div class="modal fade" id="modalExecutarPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalExecutarPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-play mr-2"></i>Executar Promedsys
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Data e hora de execução"
                                    type="datetime-local"
                                    required
                                    :validate="validate"
                                    v-model="execucao.dt_execucao"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Cancelar
                        </button>
                        <az-submit @click="confirmar_execucao()">
                            Confirmar
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document" style="max-width: 90vw; height: 86vh;">
                <div class="modal-content" v-if="item" style="height: 100%;">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalhes do Log
                            <span class="badge badge-secondary ml-2"># {{ item.id_promedsys_log }}</span>
                            <span class="badge badge-pill ml-2" :class="item.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                {{ item.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                            <span
                                class="ml-2"
                                :class="isEnvio(item) ? 'text-warning' : 'text-info'"
                                :title="isEnvio(item) ? 'Envio' : 'Consulta'"
                                data-toggle="tooltip"
                                data-placement="top"
                                style="font-size: 0.75rem;"
                            >
                                <i class="mr-1" :class="isEnvio(item) ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                                {{ isEnvio(item) ? 'Envio' : 'Consulta' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Cabeçalho fixo -->
                        <div class="row mb-3">
                            <div class="col col-12 col-md-6">
                                <label class="text-muted small mb-0">Endpoint</label>
                                <div class="font-weight-bold">{{ endpointExibicao(item) }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">Criado em</label>
                                <div>{{ formatarData(item.created_at) }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">{{ isEnvio(item) ? 'Data do envio' : 'Última consulta' }}</label>
                                <div class="font-weight-bold">{{ formatarData(item.dt_ultima_consulta) }}</div>
                            </div>
                        </div>

                        <div v-if="!item.fl_sucesso && item.st_erro" class="alert alert-danger mb-3">
                            <i class="fas fa-exclamation-circle mr-2"></i>{{ item.st_erro }}
                        </div>

                        <div v-if="resumoConsulta(item)" class="d-flex flex-wrap mb-3">
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Total recebido: <strong>{{ resumoConsulta(item).qt_total_recebido }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Processados: <strong>{{ resumoConsulta(item).qt_processado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Inconsistências: <strong>{{ qtdInconsistencias(item) }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Encontrados: <strong>{{ resumoConsulta(item).qt_encontrado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Não encontrados: <strong>{{ resumoConsulta(item).qt_nao_encontrado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Atualizados: <strong>{{ resumoConsulta(item).qt_atualizado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Erros: <strong>{{ resumoConsulta(item).qt_erro }}</strong>
                            </span>
                        </div>
                        <div v-else-if="isEnvio(item) && (dadosEnvio(item) || protocoloEnvio(item))" class="d-flex flex-wrap mb-3">
                            <span v-if="protocoloEnvio(item)" class="badge badge-warning border mr-2 mb-2 p-2">
                                <i class="fas fa-barcode mr-1"></i>Protocolo: <strong>{{ protocoloEnvio(item) }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item) && dadosEnvio(item).guiasContidasRemessa != null" class="badge badge-light border mr-2 mb-2 p-2">
                                Guias na remessa: <strong>{{ dadosEnvio(item).guiasContidasRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item) && dadosEnvio(item).identificadorRemessa != null" class="badge badge-light border mr-2 mb-2 p-2">
                                Identificador da remessa: <strong>{{ dadosEnvio(item).identificadorRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item) && dadosEnvio(item).tokenRemessa" class="badge badge-light border mr-2 mb-2 p-2">
                                Token da remessa: <strong>{{ dadosEnvio(item).tokenRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item) && dadosEnvio(item).dataHoraRegistroRemessa" class="badge badge-light border mr-2 mb-2 p-2">
                                Registro da remessa: <strong>{{ formatarData(dadosEnvio(item).dataHoraRegistroRemessa) }}</strong>
                            </span>
                        </div>

                        <!-- CÓDIGO ANTIGO: compatibilidade com logs legados; remover quando não houver mais registros antigos. -->
                        <template v-if="logAntigo(item)">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" id="tab-data" data-toggle="tab" href="#pane-data" role="tab">Dados (js_data)</a>
                                </li>
                            </ul>
                            <div class="tab-content pt-3">
                                <div class="tab-pane fade show active" id="pane-data" role="tabpanel">
                                    <div class="mb-2">
                                        <az-input
                                            label="Pesquisar no JSON"
                                            v-model="buscaJsonDados"
                                            placeholder="Pesquisar..."
                                        />
                                        <div v-if="buscaJsonDados" class="small text-muted mt-1">
                                            {{ contarOcorrenciasJson(item.js_data, buscaJsonDados) }} ocorrência(s) encontrada(s)
                                        </div>
                                    </div>
                                    <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;" v-html="formatarJsonComBusca(item.js_data, buscaJsonDados)"></pre>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                        <!-- Abas -->
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab-req-res" data-toggle="tab" href="#pane-req-res" role="tab">Request / Response</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab-data" data-toggle="tab" href="#pane-data" role="tab">Dados</a>
                            </li>
                            <li v-if="isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-guias-enviadas" data-toggle="tab" href="#pane-guias-enviadas" role="tab">Guias enviadas</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab-guias-processadas" data-toggle="tab" href="#pane-guias-processadas" role="tab">
                                    Guias processadas
                                    <span class="badge badge-light ml-1" v-if="guiasProcessadas(item).length">{{ guiasProcessadas(item).length }}</span>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content pt-3">
                            <!-- Aba Request / Response -->
                            <div class="tab-pane fade show active" id="pane-req-res" role="tabpanel">
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Request</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;">{{ formatarJson(item.js_request) }}</pre>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Response</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;">{{ formatarJson(item.js_response) }}</pre>
                                    </div>
                                </div>
                            </div>

                            <!-- Aba Dados (js_data) -->
                            <div class="tab-pane fade" id="pane-data" role="tabpanel">
                                <div class="mb-2">
                                    <az-input
                                        label="Pesquisar no JSON"
                                        v-model="buscaJsonDados"
                                        placeholder="Pesquisar..."
                                    />
                                    <div v-if="buscaJsonDados" class="small text-muted mt-1">
                                        {{ contarOcorrenciasJson(item.js_data, buscaJsonDados) }} ocorrência(s) encontrada(s)
                                    </div>
                                </div>
                                <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;" v-html="formatarJsonComBusca(item.js_data, buscaJsonDados)"></pre>
                            </div>

                            <div v-if="isEnvio(item)" class="tab-pane fade" id="pane-guias-enviadas" role="tabpanel">
                                <div v-if="guiasEnviadas(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>N. guia prestador</th>
                                                <th>N. conta prestador</th>
                                                <th>Paciente</th>
                                                <th>Medico</th>
                                                <th>Qtd. procedimentos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasEnviadas(item)" :key="`guia-enviada-${index}`">
                                                <td>{{ guia.numeroGuiaPrestador || '-' }}</td>
                                                <td>{{ guia.numeroContaPrestador || '-' }}</td>
                                                <td>{{ guia.dadosPaciente && guia.dadosPaciente.nomePaciente ? guia.dadosPaciente.nomePaciente : '-' }}</td>
                                                <td>{{ nomeMedicoGuia(guia) }}</td>
                                                <td>{{ quantidadeProcedimentosGuia(guia) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia enviada encontrada na request." icon="fas fa-paper-plane" />
                            </div>

                            <div class="tab-pane fade" id="pane-guias-processadas" role="tabpanel">
                                <div class="d-flex flex-wrap align-items-center justify-content-between mb-2" style="gap: 0.5rem;">
                                    <div style="min-width: 220px;">
                                        <az-input
                                            icon="fas fa-search"
                                            placeholder="Filtrar por guia, paciente..."
                                            :mb="false"
                                            v-model="buscaGuiaProcessada"
                                        />
                                    </div>
                                    <div class="btn-group btn-group-sm" v-if="guiasProcessadas(item).length">
                                        <button type="button" class="btn" :class="filtroGuiaProcessada === 'T' ? 'btn-secondary' : 'btn-outline-secondary'" @click="filtroGuiaProcessada = 'T'">
                                            Todas ({{ guiasProcessadas(item).length }})
                                        </button>
                                        <button type="button" class="btn" :class="filtroGuiaProcessada === 'S' ? 'btn-success' : 'btn-outline-success'" @click="filtroGuiaProcessada = 'S'">
                                            Sucesso ({{ guiasComSucesso(item).length }})
                                        </button>
                                        <button type="button" class="btn" :class="filtroGuiaProcessada === 'E' ? 'btn-danger' : 'btn-outline-danger'" @click="filtroGuiaProcessada = 'E'">
                                            Erro ({{ guiasComErro(item).length }})
                                        </button>
                                        <button type="button" class="btn" :class="filtroGuiaProcessada === 'I' ? 'btn-warning' : 'btn-outline-warning'" @click="filtroGuiaProcessada = 'I'">
                                            Inconsistências ({{ guiasComInconsistencia(item).length }})
                                        </button>
                                    </div>
                                </div>

                                <div v-if="guiasProcessadasFiltradas(item).length" class="table-responsive" style="max-height: calc(90vh - 300px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Guia</th>
                                                <th>Paciente</th>
                                                <th>Tipo</th>
                                                <th>Atendimento</th>
                                                <th>Data</th>
                                                <th>Status</th>
                                                <th>Situação</th>
                                                <th>Erro / Inconsistências</th>
                                                <th class="text-right">Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guiaLog, index) in guiasProcessadasFiltradas(item)" :key="`guia-log-${index}`">
                                                <td class="text-nowrap" :title="`ID: ${guiaLog.id_guia}`">
                                                    {{ (guiaLog.guia && (guiaLog.guia.guia_formatada || guiaLog.guia.st_numero_interno)) || ('#' + guiaLog.id_guia) }}
                                                </td>
                                                <td>{{ pacienteGuiaLog(guiaLog) || '-' }}</td>
                                                <td>{{ (guiaLog.guia && guiaLog.guia.nome) || '-' }}</td>
                                                <td class="text-nowrap">
                                                    <span v-if="guiaLog.guia && guiaLog.guia.id_atendimento != null">#{{ guiaLog.guia.id_atendimento }}</span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td class="text-nowrap">
                                                    {{ dataAtendimentoGuiaLog(guiaLog) ? formatarData(dataAtendimentoGuiaLog(guiaLog)) : '-' }}
                                                </td>
                                                <td class="text-nowrap">
                                                    <span v-if="guiaLog.st_status_anterior || guiaLog.st_status_atual">
                                                        <strong>{{ guiaLog.st_status_anterior || '-' }}</strong>
                                                        <i class="fas fa-arrow-right mx-1"></i>
                                                        <strong>{{ guiaLog.st_status_atual || '-' }}</strong>
                                                    </span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td class="text-nowrap">
                                                    <span class="badge badge-pill" :class="guiaLog.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                                        <i :class="guiaLog.fl_sucesso ? 'fas fa-check' : 'fas fa-times'"></i>
                                                        {{ guiaLog.fl_sucesso ? 'Sucesso' : 'Erro' }}
                                                    </span>
                                                </td>
                                                <td style="max-width: 260px;">
                                                    <div v-if="!guiaLog.fl_sucesso && guiaLog.st_erro" class="text-danger small text-truncate" :title="guiaLog.st_erro">
                                                        <i class="fas fa-exclamation-circle mr-1"></i>{{ guiaLog.st_erro }}
                                                    </div>
                                                    <span
                                                        v-if="inconsistenciasGuiaLog(guiaLog).length"
                                                        class="badge badge-warning text-nowrap"
                                                        :title="inconsistenciasGuiaLog(guiaLog).map(formatarInconsistencia).join(' | ')"
                                                    >
                                                        <i class="fas fa-exclamation-triangle mr-1"></i>{{ inconsistenciasGuiaLog(guiaLog).length }} inconsistência(s)
                                                    </span>
                                                    <span v-if="!(!guiaLog.fl_sucesso && guiaLog.st_erro) && !inconsistenciasGuiaLog(guiaLog).length">-</span>
                                                </td>
                                                <td class="text-right text-nowrap">
                                                    <button
                                                        v-if="alteracoesGuiaLog(guiaLog).length || movimentacoesGuiaLog(guiaLog).length"
                                                        type="button"
                                                        class="btn btn-outline-secondary btn-sm mr-2"
                                                        @click="abrirModalAlteracoes(guiaLog)"
                                                    >
                                                        <i class="fas fa-pen mr-1"></i>Alterações ({{ alteracoesGuiaLog(guiaLog).length }})
                                                        <span v-if="movimentacoesGuiaLog(guiaLog).length" class="badge badge-info ml-1">
                                                            {{ movimentacoesGuiaLog(guiaLog).length }} mov.
                                                        </span>
                                                    </button>
                                                    <button
                                                        v-if="inconsistenciasGuiaLog(guiaLog).length"
                                                        type="button"
                                                        class="btn btn-outline-secondary btn-sm"
                                                        @click="abrirModalInconsistencia(guiaLog)"
                                                    >
                                                        <i class="fas fa-code mr-1"></i>Resposta bruta
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia encontrada para este filtro." icon="fas fa-file-medical" />
                            </div>
                        </div>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalInconsistenciaPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalInconsistenciaPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="max-width: 74vw;">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #f8f9fa; border-bottom: 1px solid #eceff3;">
                        <h5 class="modal-title">
                            Detalhe do processamento da guia
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6 mb-3 mb-md-0">
                                <label class="text-muted small mb-1">Guia correspondente na response</label>
                                <pre class="bg-light p-2 rounded small mb-0" style="max-height: 500px; overflow-y: scroll;">{{ formatarJson(guiaResponseSelecionada) }}</pre>
                            </div>
                            <div class="col col-12 col-md-6">
                                <label class="text-muted small mb-1">Guia no log (guia_logs)</label>
                                <pre class="bg-light p-2 rounded small mb-0" style="max-height: 500px; overflow-y: scroll;">{{ formatarJson(inconsistenciaSelecionada) }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalAlteracoesPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalAlteracoesPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #f8f9fa; border-bottom: 1px solid #eceff3;">
                        <h5 class="modal-title">
                            Alterações da guia
                            <span class="badge badge-secondary ml-2" v-if="guiaAlteracoesSelecionada && guiaAlteracoesSelecionada.id_guia != null">
                                # {{ guiaAlteracoesSelecionada.id_guia }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab-alteracoes" data-toggle="tab" href="#pane-alteracoes" role="tab">
                                    Alterações
                                    <span class="badge badge-light ml-1" v-if="alteracoesSelecionadas.length">{{ alteracoesSelecionadas.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item" v-if="movimentacoesSelecionadas.length">
                                <a class="nav-link" id="tab-movimentacao" data-toggle="tab" href="#pane-movimentacao" role="tab">
                                    Movimentação
                                    <span class="badge badge-light ml-1">{{ movimentacoesSelecionadas.length }}</span>
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab-guia-json" data-toggle="tab" href="#pane-guia-json" role="tab">Dados da guia (JSON)</a>
                            </li>
                        </ul>

                        <div class="tab-content pt-3">
                            <div class="tab-pane fade show active" id="pane-alteracoes" role="tabpanel">
                                <div v-if="alteracoesSelecionadas.length" class="table-responsive" style="max-height: 55vh; overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Área</th>
                                                <th>Item</th>
                                                <th>Campo</th>
                                                <th>De</th>
                                                <th>Para</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(alt, index) in alteracoesSelecionadas" :key="`modal-alt-${index}`">
                                                <td>{{ alt.area }}</td>
                                                <td>{{ alt.item }}</td>
                                                <td>{{ alt.campo }}</td>
                                                <td>{{ alt.de }}</td>
                                                <td>{{ alt.para }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma alteração encontrada." icon="fas fa-pen" />
                            </div>

                            <div v-if="movimentacoesSelecionadas.length" class="tab-pane fade" id="pane-movimentacao" role="tabpanel">
                                <div class="table-responsive" style="max-height: 55vh; overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Tipo</th>
                                                <th>Item</th>
                                                <th>Código</th>
                                                <th class="text-right">Recebido</th>
                                                <th class="text-right">Glosado</th>
                                                <th class="text-right">Qtd. glosa</th>
                                                <th>Retorno</th>
                                                <th>Tipo mov.</th>
                                                <th>Situação</th>
                                                <th>Motivo / Mensagem</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(mov, index) in movimentacoesSelecionadas" :key="`modal-mov-${index}`">
                                                <td class="text-nowrap">{{ mov.tipo_item || '-' }}</td>
                                                <td class="text-nowrap">{{ mov.id != null ? '#' + mov.id : '-' }}</td>
                                                <td class="text-nowrap">{{ mov.codigo || '-' }}</td>
                                                <td class="text-right text-nowrap">{{ formatarValorMov(mov.recebido) }}</td>
                                                <td class="text-right text-nowrap">{{ formatarValorMov(mov.glosado) }}</td>
                                                <td class="text-right">{{ mov.qtde_glosa != null ? mov.qtde_glosa : '-' }}</td>
                                                <td class="text-nowrap">
                                                    {{ formatarDataSimples(mov.dt_retorno) }}
                                                    <i
                                                        v-if="mov.retorno != null"
                                                        class="ml-1"
                                                        :class="mov.retorno ? 'fas fa-check text-success' : 'fas fa-times text-danger'"
                                                        :title="mov.retorno ? 'Retorno registrado' : 'Retorno não registrado'"
                                                    ></i>
                                                </td>
                                                <td class="text-nowrap">{{ mov.tipo_mov || '-' }}</td>
                                                <td class="text-nowrap">
                                                    <span v-if="mov.sucesso != null" class="badge badge-pill" :class="mov.sucesso ? 'badge-success' : 'badge-danger'">
                                                        <i :class="mov.sucesso ? 'fas fa-check' : 'fas fa-times'"></i>
                                                        {{ mov.sucesso ? 'Sucesso' : 'Erro' }}
                                                    </span>
                                                    <span v-else>-</span>
                                                </td>
                                                <td style="max-width: 280px;">
                                                    <div v-if="mov.motivo_recusa" class="text-danger small">{{ mov.motivo_recusa }}</div>
                                                    <div v-if="mov.msg" class="text-muted small">{{ mov.msg }}</div>
                                                    <span v-if="!mov.motivo_recusa && !mov.msg">-</span>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="pane-guia-json" role="tabpanel">
                                <pre class="bg-light p-2 rounded small mb-0" style="max-height: 55vh; overflow-y: auto;">{{ formatarJson(guiaAlteracoesSelecionada && guiaAlteracoesSelecionada.guia) }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzPeriodo from "../../shared/forms/AzPeriodo.vue";
import AzSubmit from "../../util/AzSubmit.vue";

export default {
    components: {
        ConfigMainTitle,
        AzInput,
        AzPeriodo,
        AzSubmit,
    },

    data() {
        return {
            dados: {
                data: [],
                last_page: 0,
            },
            lista: [],
            filtros: {
                page: 1,
                size: 20,
                periodo: '',
                inicio: null,
                fim: null,
            },
            bloqueia_sync_periodo: true,
            item: null,
            execucao: {
                dt_execucao: null,
            },
            inconsistenciaSelecionada: null,
            guiaResponseSelecionada: null,
            guiaAlteracoesSelecionada: null,
            alteracoesSelecionadas: [],
            movimentacoesSelecionadas: [],
            buscaJsonDados: "",
            filtroGuiaProcessada: "T",
            buscaGuiaProcessada: "",
            tipoFiltro: "T",
            textoPesquisa: (this.$route && this.$route.query && this.$route.query.search) || "",
            opcoesTipo: [
                { value: "T", label: "Todos" },
                { value: "E", label: "Envio" },
                { value: "C", label: "Consulta" },
            ],
            validate: false,
        };
    },

    computed: {
        lista_filtrada: function () {
            return this.lista || [];
        },
    },

    watch: {
        tipoFiltro() {
            this.recarregar(1);
        },
    },

    methods: {
        // Código antigo: identifica logs sem a relação guia_logs.
        logAntigo(log) {
            return !log || !Array.isArray(log.guia_logs);
        },

        obterJsonCampo(log, campo) {
            const valor = log && log[campo] ? log[campo] : null;
            if (!valor) return null;

            if (typeof valor === "string") {
                try {
                    return JSON.parse(valor);
                } catch {
                    return null;
                }
            }

            return valor;
        },

        obterJsData(log) {
            return this.obterJsonCampo(log, "js_data");
        },

        obterJsResponse(log) {
            return this.obterJsonCampo(log, "js_response");
        },

        obterJsRequest(log) {
            return this.obterJsonCampo(log, "js_request");
        },

        resumoConsulta(log) {
            const jsData = this.obterJsData(log);
            if (jsData && jsData.resumo) return jsData.resumo;

            const jsResponse = this.obterJsResponse(log);
            return jsResponse && jsResponse.resumo ? jsResponse.resumo : null;
        },

        qtdInconsistencias(log) {
            const resumo = this.resumoConsulta(log);

            if (resumo && resumo.qt_inconsistencia != null) {
                return resumo.qt_inconsistencia;
            }

            return this.guiasComInconsistencia(log).length;
        },

        guiasEnviadas(log) {
            const jsRequest = this.obterJsRequest(log);
            return jsRequest && Array.isArray(jsRequest.guias) ? jsRequest.guias : [];
        },

        guiasResponse(log) {
            const jsResponse = this.obterJsResponse(log);
            if (!jsResponse) return [];

            if (Array.isArray(jsResponse)) return jsResponse;
            if (Array.isArray(jsResponse.guias)) return jsResponse.guias;
            if (Array.isArray(jsResponse.data)) return jsResponse.data;
            if (jsResponse.data && Array.isArray(jsResponse.data.guias)) return jsResponse.data.guias;
            if (Array.isArray(jsResponse.dados)) return jsResponse.dados;
            if (jsResponse.dados && Array.isArray(jsResponse.dados.guias)) return jsResponse.dados.guias;

            return [];
        },

        nomeMedicoGuia(guia) {
            if (!guia) return "-";

            if (guia.dadosProfissionalExecutante && guia.dadosProfissionalExecutante.nomeProfissional) {
                return guia.dadosProfissionalExecutante.nomeProfissional;
            }

            if (guia.dadosProfissionalSolicitante && guia.dadosProfissionalSolicitante.nomeProfissional) {
                return guia.dadosProfissionalSolicitante.nomeProfissional;
            }

            return "-";
        },

        quantidadeProcedimentosGuia(guia) {
            return guia && Array.isArray(guia.procedimentosExames) ? guia.procedimentosExames.length : 0;
        },

        // Aceita variações no nome da relação retornada pela API (PROMEDSYS_LOG_GUIA)
        guiasProcessadas(log) {
            if (!log) return [];
            const candidatos = [log.guia_logs, log.guias_log, log.promedsys_log_guias, log.guias_processadas, log.log_guias, log.guias];
            const encontrado = candidatos.find((valor) => Array.isArray(valor));
            return encontrado || [];
        },

        guiasComSucesso(log) {
            return this.guiasProcessadas(log).filter((guiaLog) => guiaLog.fl_sucesso);
        },

        guiasComErro(log) {
            return this.guiasProcessadas(log).filter((guiaLog) => !guiaLog.fl_sucesso);
        },

        guiasComInconsistencia(log) {
            return this.guiasProcessadas(log).filter((guiaLog) => this.inconsistenciasGuiaLog(guiaLog).length > 0);
        },

        guiasProcessadasFiltradas(log) {
            let lista = this.guiasProcessadas(log);

            if (this.filtroGuiaProcessada === "S") lista = lista.filter((guiaLog) => guiaLog.fl_sucesso);
            if (this.filtroGuiaProcessada === "E") lista = lista.filter((guiaLog) => !guiaLog.fl_sucesso);
            if (this.filtroGuiaProcessada === "I") lista = lista.filter((guiaLog) => this.inconsistenciasGuiaLog(guiaLog).length > 0);

            if (this.buscaGuiaProcessada) {
                const reg = this.$util.getregex(this.buscaGuiaProcessada);
                lista = lista.filter((guiaLog) => reg.test(JSON.stringify(guiaLog)));
            }

            return lista;
        },

        pacienteGuiaLog(guiaLog) {
            const atendimento = guiaLog && guiaLog.guia && guiaLog.guia.atendimento;
            return atendimento && atendimento.paciente ? atendimento.paciente.st_nome : null;
        },

        dataAtendimentoGuiaLog(guiaLog) {
            const atendimento = guiaLog && guiaLog.guia && guiaLog.guia.atendimento;
            return atendimento ? atendimento.dt_inicio : null;
        },

        inconsistenciasGuiaLog(guiaLog) {
            const valor = this.obterJsonCampo(guiaLog, "js_inconsistencias");
            return Array.isArray(valor) ? valor : [];
        },

        obterJsAlteracoes(guiaLog) {
            const valor = this.obterJsonCampo(guiaLog, "js_alteracoes");
            return valor && typeof valor === "object" && !Array.isArray(valor) ? valor : null;
        },

        // movimentacao: [{ tipo_item, id, sucesso, codigo, recebido, glosado, qtde_glosa, dt_retorno, tipo_mov, retorno, msg, motivo_recusa }]
        movimentacoesGuiaLog(guiaLog) {
            const valor = this.obterJsAlteracoes(guiaLog);
            return valor && Array.isArray(valor.movimentacao) ? valor.movimentacao.filter((mov) => mov && typeof mov === "object") : [];
        },

        alteracoesGuiaLog(guiaLog) {
            const valor = this.obterJsAlteracoes(guiaLog);
            if (!valor) return [];

            const ehDiff = (obj) => obj && typeof obj === "object" && ("de" in obj || "para" in obj);
            const linhas = [];

            const adicionarLinha = (area, item, campo, diff) => {
                linhas.push({
                    area,
                    item,
                    campo,
                    de: diff && diff.de != null ? diff.de : "-",
                    para: diff && diff.para != null ? diff.para : "-",
                });
            };

            Object.keys(valor).forEach((area) => {
                // movimentação é exibida em aba própria
                if (area === "movimentacao") return;

                const conteudo = valor[area];

                // grupo de itens (ex.: procedimentos, consumos): [{ id, campos: { campo: {de, para} } }]
                if (Array.isArray(conteudo)) {
                    conteudo.forEach((item) => {
                        const campos = item && item.campos ? item.campos : {};
                        const identificador = item && item.id != null ? `#${item.id}` : "-";
                        Object.keys(campos).forEach((campo) => adicionarLinha(area, identificador, campo, campos[campo]));
                    });
                    return;
                }

                // alteração direta de um campo da guia: { campo: {de, para} }
                if (ehDiff(conteudo)) {
                    adicionarLinha("guia", "-", area, conteudo);
                    return;
                }

                // grupo sem lista, com campos diretos: { campo: {de, para} }
                if (conteudo && typeof conteudo === "object") {
                    Object.keys(conteudo).forEach((campo) => {
                        if (ehDiff(conteudo[campo])) adicionarLinha(area, "-", campo, conteudo[campo]);
                    });
                }
            });

            return linhas;
        },

        formatarInconsistencia(inc) {
            if (inc == null) return "-";
            if (typeof inc === "string") return inc;
            if (typeof inc === "object") {
                if (inc.mensagem) return inc.mensagem;
                if (inc.descricao) return inc.descricao;
                return this.formatarJson(inc);
            }
            return String(inc);
        },

        dadosEnvio(log) {
            const jsData = this.obterJsData(log);
            const jsResponse = this.obterJsResponse(log);

            const origem = [jsResponse, jsData].find((payload) => !!payload);
            if (!origem) return null;

            const possuiDadosRemessa =
                origem.tokenRemessa ||
                origem.identificadorRemessa != null ||
                origem.guiasContidasRemessa != null ||
                origem.dataHoraRegistroRemessa;

            return possuiDadosRemessa ? origem : null;
        },

        protocoloEnvio(log) {
            if (log && log.st_protocolo != null && log.st_protocolo !== "") return log.st_protocolo;

            const jsData = this.obterJsData(log);
            return jsData && jsData.protocolo != null && jsData.protocolo !== "" ? jsData.protocolo : null;
        },

        isEnvio(log) {
            if (!log) return false;

            if (log.fl_envio != null) return !!log.fl_envio;

            const jsData = this.obterJsData(log);

            if (jsData && jsData.envio) return true;
            if (this.dadosEnvio(log)) return true;

            return !!(log.st_endpoint && /\/protocolo(\/|$)/i.test(String(log.st_endpoint)));
        },

        endpointExibicao(log) {
            if (!log || !log.st_endpoint) return "-";

            const endpoint = String(log.st_endpoint);
            if (!this.isEnvio(log)) return endpoint;

            const identificador =
                this.dadosEnvio(log) && this.dadosEnvio(log).identificadorRemessa != null
                    ? String(this.dadosEnvio(log).identificadorRemessa)
                    : "";

            if (!identificador) return endpoint;

            const endpointSemBarraFinal = endpoint.replace(/\/$/, "");

            if (/\/protocolo(\/|$)/i.test(endpointSemBarraFinal) && !endpointSemBarraFinal.endsWith("/" + identificador)) {
                return `${endpointSemBarraFinal}/${identificador}`;
            }

            return endpoint;
        },

        carregar(page = 1) {
            this.filtros.page = page;
            const parms = {
                page: this.filtros.page,
                size: this.filtros.size,
                dt_inicio: this.filtros.inicio,
                dt_fim: this.filtros.fim,
                search: this.textoPesquisa,
                envio: this.tipoFiltro,
            };

            this.$util.load(this, {
                service: "promedsys_logs",
                parms,
                loadTo: (res) => {
                    const payload = this.normalizar_paginacao(res);
                    this.dados = payload.dados;
                    this.lista = payload.lista;

                    if (page > 1 && this.dados && this.dados.last_page && page > this.dados.last_page) {
                        this.carregar(1);
                    }
                },
            });
        },

        recarregar(page = 1) {
            this.carregar(page);
        },

        sincronizarPeriodo() {
            if (this.bloqueia_sync_periodo) return;
            this.recarregar(1);
        },

        normalizar_paginacao(res) {
            if (Array.isArray(res)) {
                return {
                    dados: {
                        data: res,
                        last_page: 1,
                    },
                    lista: res,
                };
            }

            if (res && Array.isArray(res.data)) {
                return {
                    dados: res,
                    lista: res.data,
                };
            }

            if (res && res.data && Array.isArray(res.data.data)) {
                return {
                    dados: res.data,
                    lista: res.data.data,
                };
            }

            if (res && res.data && res.data.lista && Array.isArray(res.data.lista.data)) {
                return {
                    dados: res.data.lista,
                    lista: res.data.lista.data,
                };
            }

            return {
                dados: {
                    data: [],
                    last_page: 0,
                },
                lista: [],
            };
        },

        abrir_modal_executar() {
            this.validate = false;
            this.execucao = { dt_execucao: null };
            this.$nextTick(() => {
                $("#modalExecutarPromedSys").modal("show");
            });
        },

        confirmar_execucao() {
            this.validate = true;
            if (!this.execucao.dt_execucao) return;

            this.$util.atualizar(this, {
                service: "campanhas",
                func: "executar_agora_promedsys",
                modal: "modalExecutarPromedSys",
                dados: {
                    dt_ultima_execucao: this.execucao.dt_execucao,
                },
                toast: true,
                msg: "Execução iniciada com sucesso.",
                callback: () => {
                    this.carregar();
                },
            });
        },

        editar_log(log) {
            this.item = log;
            this.buscaJsonDados = "";
            this.filtroGuiaProcessada = "T";
            this.buscaGuiaProcessada = "";
            this.inconsistenciaSelecionada = null;
            this.guiaResponseSelecionada = null;
            this.guiaAlteracoesSelecionada = null;
            this.alteracoesSelecionadas = [];
            this.movimentacoesSelecionadas = [];
            this.$nextTick(() => {
                $("#modalInconsistenciaPromedSys").modal("hide");
                $("#modalAlteracoesPromedSys").modal("hide");
                $("#modalPromedSys").modal("show");
                $(this.logAntigo(log) ? '#tab-data' : '#tab-req-res').tab('show');
            });
        },

        abrirModalInconsistencia(guiaLog) {
            this.inconsistenciaSelecionada = guiaLog;
            this.guiaResponseSelecionada = this.obterGuiaResponsePorInconsistencia(guiaLog);
            this.$nextTick(() => {
                $("#modalInconsistenciaPromedSys").modal("show");
            });
        },

        abrirModalAlteracoes(guiaLog) {
            this.guiaAlteracoesSelecionada = guiaLog;
            this.alteracoesSelecionadas = this.alteracoesGuiaLog(guiaLog);
            this.movimentacoesSelecionadas = this.movimentacoesGuiaLog(guiaLog);
            this.$nextTick(() => {
                $("#modalAlteracoesPromedSys").modal("show");
                const abrirMovimentacao = !this.alteracoesSelecionadas.length && this.movimentacoesSelecionadas.length;
                $(abrirMovimentacao ? "#tab-movimentacao" : "#tab-alteracoes").tab("show");
            });
        },

        formatarValorMov(valor) {
            if (valor == null || valor === "") return "-";
            return this.$util.formatMoeda(valor);
        },

        // datas sem hora (YYYY-MM-DD) não passam pelo Date para evitar deslocamento de fuso
        formatarDataSimples(valor) {
            if (!valor) return "-";
            const match = String(valor).match(/^(\d{4})-(\d{2})-(\d{2})$/);
            return match ? `${match[3]}/${match[2]}/${match[1]}` : this.formatarData(String(valor));
        },

        obterGuiaResponsePorInconsistencia(guiaLog) {
            if (!this.item || !guiaLog || guiaLog.id_guia == null) return null;

            const guiasResponse = this.guiasResponse(this.item);
            if (!Array.isArray(guiasResponse) || !guiasResponse.length) return null;

            const idGuia = String(guiaLog.id_guia).trim();

            return (
                guiasResponse.find((guiaResponse) => {
                    const id = guiaResponse.id_guia != null ? guiaResponse.id_guia : guiaResponse.id;
                    return id != null && String(id).trim() === idGuia;
                }) || null
            );
        },

        formatarData(valor) {
            if (!valor) return "-";
            const d = new Date(valor.replace(" ", "T"));
            if (isNaN(d)) return valor;
            return d.toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },

        formatarJson(valor) {
            if (!valor) return "-";
            try {
                const obj = typeof valor === "string" ? JSON.parse(valor) : valor;
                return JSON.stringify(obj, null, 2);
            } catch {
                return valor;
            }
        },

        escapeHtml(valor) {
            if (valor == null) return "";

            return String(valor)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },

        escaparRegex(valor) {
            return valor.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        },

        formatarJsonComBusca(valor, busca) {
            const jsonFormatado = this.formatarJson(valor);
            const jsonEscapado = this.escapeHtml(jsonFormatado);

            if (!busca) return jsonEscapado;

            const regex = new RegExp(`(${this.escaparRegex(this.escapeHtml(busca))})`, "gi");
            return jsonEscapado.replace(regex, '<mark class="px-1">$1</mark>');
        },

        contarOcorrenciasJson(valor, busca) {
            if (!busca) return 0;

            const jsonFormatado = this.formatarJson(valor);
            const ocorrencias = jsonFormatado.match(new RegExp(this.escaparRegex(busca), "gi"));

            return ocorrencias ? ocorrencias.length : 0;
        },

        formatarDataFiltro(data) {
            if (!data) return null;
            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const dia = String(data.getDate()).padStart(2, "0");
            return `${ano}-${mes}-${dia}`;
        },

        definirPeriodoPadrao() {
            const hoje = new Date();
            const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

            this.filtros = {
                ...this.filtros,
                inicio: this.formatarDataFiltro(inicio),
                fim: this.formatarDataFiltro(fim),
            };
        },
    },

    mounted() {
        this.definirPeriodoPadrao();
        this.$nextTick(() => {
            this.bloqueia_sync_periodo = false;
            this.carregar(1);
        });

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Logs Promedsys", path: "" },
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);
    },
};
</script>